var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLodging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 50 50",
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 32v8h4v-12h-46v-16.34c0-1.123-.869-2.042-2-2.042-1.127 0-2 .918-2 2.042v28.34h4v-8h42zm-35.67-12.148c2.041 0 3.687-1.653 3.687-3.694 0-2.027-1.646-3.675-3.687-3.675-2.038 0-3.683 1.647-3.683 3.675 0 2.04 1.645 3.694 3.683 3.694zm39.67 5.148l-.014-4.871c-.013-1.606-1.36-2.618-2.939-2.809l-28.957-2.833-.215-.009c-1.006 0-1.875.834-1.875 1.835v5.687h-7.453c-1.011 0-1.826.5-1.826 1.499 0 1.015.815 1.501 1.826 1.501h41.453z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLodging);
export default __webpack_public_path__ + "static/media/lodging.55af9ec33dad2342028dbcbbf70d0a67.svg";
export { ForwardRef as ReactComponent };